import { P2GImage } from '@parcel2go/core-ui';

const ECommerceLogoMap = {
  onbuy:
    'https://images.ctfassets.net/v78wipeni189/63yZWMwhVOTumuy81CZAVl/07a82dc5cb83f1ea83a94ba830da34fb/ecommerce-onbuy-logo.svg',
  prestashop:
    'https://images.ctfassets.net/v78wipeni189/6qilISFDQwQ9k4RWu2WkPn/4aca78812043d855ed44aa4b56c55af4/ecommerce-prestashop-logo.svg',
  wix: 'https://images.ctfassets.net/v78wipeni189/7yCMFZXRNaIQ3OdrhLb1Lj/a8f7e81015821e6ea1460611f9fbbd2e/ecommerce-wix-logo.svg',
  magento:
    'https://images.ctfassets.net/v78wipeni189/3lbQCbE9bw3fkTGW1cXm6z/74c46d5a4f886e546050ba69fd34b5d9/ecommerce-magento-logo.svg',
  woocommerce:
    'https://images.ctfassets.net/v78wipeni189/3RT0jjyqUuabqWGcGRxw3q/8260c09108a12ebd2d5af3788e3ae298/ecommerce-woocommerce-logo.svg',
  bigcommerce:
    'https://images.ctfassets.net/v78wipeni189/lLeKl0OjQW9QlfcqPZYdt/15c7ec7fdbeb4f33c73b8f24f9ad06b5/ecommerce-bigcommerce-logo.svg',
  bluepark:
    'https://images.ctfassets.net/v78wipeni189/4cAKzsuRQGCF9LxHez18lS/e4d719f23829b6c32a047579e11af073/ecommerce-bluepark-logo.svg',
  shopwired:
    'https://images.ctfassets.net/v78wipeni189/61Y1eVB7D3ugRbGcRxMyRW/3943a1d63baad7777118d2df6c140174/ecommerce-shopwired-logo.svg',
  ekm: 'https://images.ctfassets.net/v78wipeni189/5Fj9HOPSwsfHrXeQYd5CPL/60a8a44bc3a1ebf820d002bacbdb42e5/ecommerce-ekm-logo.svg',
  squarespace:
    'https://images.ctfassets.net/v78wipeni189/3zTeLBITsTMAYf4bfpgUsf/338f10d5222af169acb489270479b95c/ecommerce-squarespace-logo.svg',
  amazon:
    'https://images.ctfassets.net/v78wipeni189/2mVu0ewzgZRTHZ0OcBhCcY/61593af3b4559c742c610ca5a69c5cbb/ecommerce-amazon-logo.svg',
  ebay: 'https://images.ctfassets.net/v78wipeni189/4gqrzKnlQUg0BNRIrEkXxA/b836867eac831a1f6b4af2227279571d/ecommerce-ebay-logo.svg',
  etsy: 'https://images.ctfassets.net/v78wipeni189/2twk7qOpMkPKY2PYPTVJsV/ffcb1759ab58b8ab1be411ae0fa4151e/ecommerce-etsy-logo.svg',
  noths:
    'https://images.ctfassets.net/v78wipeni189/4KH3CD9xLjQrPctNAVomIZ/acb8828da0509f19036a49496ed887a3/ecommerce-noths-logo.svg',
  shopify:
    'https://images.ctfassets.net/v78wipeni189/72tUlDxclVWGRadf0NeSOX/cc74671482f40feab2710fb109f97777/ecommerce-shopify-logo.svg',
  csv: 'https://images.ctfassets.net/v78wipeni189/6fvT1AkAbUZOeCCD0mORC8/f5cd75a9ced7f76d5c1a8cb18315940f/ecommerce-csv-logo.svg',
  grouped:
    'https://images.ctfassets.net/v78wipeni189/qZtI0sGo8w4EMxMPt2tyq/365d63e0f620a59dcf5ce76c9a8980f7/ecommerce-grouped-logo.svg',
  manual:
    'https://images.ctfassets.net/v78wipeni189/rEuByNRF9g8MxcbgtqrR9/a8ea2e9d0c649f37954537dc02a2a37c/ecommerce-manual-logo.svg',
  temu: 'https://images.ctfassets.net/v78wipeni189/UfFP5tsQUdOr8wgdpeh4y/1d512ca571b0761dd40d4c32d81d660c/ecommerce-temu-logo.svg',
  tiktok:
    'https://images.ctfassets.net/v78wipeni189/5KCZQEDzC0skPZf3p0FQIs/aa4035ef6c214f420d7bf25aeecbff22/ecommerce-tiktok-logo.svg'
};

interface props {
  integration: string;
  style?: Record<string | number, string | number>;
  title?: string;
}

const ECommerceLogo = (props: props) => (
  <span title={props.title ?? props.integration}>
    {ECommerceLogoMap[props.integration] ? (
      <P2GImage
        src={ECommerceLogoMap[props.integration]}
        style={props.style ?? { width: '100%' }}
        alt={props.integration}
      />
    ) : (
      props.title
    )}
  </span>
);

export default ECommerceLogo;
